<div class="welcome-splash" [class.show]="visible">
  <div class="card">
    <div class="logo-wrap">
      <img [src]="logoSrc" alt="Receta Medica Digital" />
    </div>

    <div class="text-wrap">
      <div class="welcome-text">
        {{ subtitle }}
      </div>

      <div class="divider"></div>

      <div class="meta">
        {{ metaText }}
      </div>
    </div>
  </div>
</div>
